// src/pages/user/Hotels/ActivitiesListPage.jsx
import React from 'react';

const ActivitiesListPage = () => {
  return (
    <div>
      <h1>Activities List</h1>
      <p>Manage guest activities here.</p>
    </div>
  );
};

export default ActivitiesListPage;
